import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  thu_tu: undefined, // optional - Thứ tự sắp xếp
  hien_thi: undefined, // required - Cho biết có hiển thị hay không
  phan_loai: undefined, // required - Phân loại
  tieu_de: undefined, // required - Tiêu đề
  mo_ta: undefined, // optional - Mô tả
  noi_dung: undefined, // required - Nội dung, định dạng MarkDown
  thoi_diem_tao: undefined, // required - Thời điểm tạo
  thoi_diem_cap_nhat: undefined, // required - Thời điểm cập nhật cuối
  nguoi_cap_nhat_id: undefined, // required, ref: mushroom_user - Người cập nhật cuối
};

// validation form
model.validForm = {
  tieu_de: [ValidService.required, ValidService.checkSpaceString],
  phan_loai: [ValidService.required, ValidService.requiredChange],
};

model.phanLoai = [
  // {
  //   value: "inapp,macos,ios,iphone,ipad,pc,windows,android,web",
  //   label: "all",
  // },
  {
    value: "inapp",
    label: "inapp",
  },
  {
    value: "macos",
    label: "macos",
  },
  {
    value: "ios",
    label: "ios",
  },
  {
    value: "iphone",
    label: "iphone",
  },
  {
    value: "ipad",
    label: "ipad",
  },
  {
    value: "pc",
    label: "pc",
  },
  {
    value: "windows",
    label: "windows",
  },
  {
    value: "android",
    label: "android",
  },
  {
    value: "web",
    label: "web",
  },
];

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-thoi_diem_tao",
  defaultSort: ["thoi_diem_tao", "descending"],
  filters: "",
  recordSelected: [],

  dataSearch: {
    value: {
      tieu_de: "",
      phan_loai: [],
      hien_thi: "",
    },
    valid: {
      thoi_diem_tao: [],
      thu_tu: [],
      mo_ta: [],
      tieu_de: []
    },
    operator: {
      tieu_de: ":regex_i:",
      phan_loai: "",
      hien_thi: "",
    },
  },
};

export default model;
